import { base64 } from 'rfc4648';

const encoder = new TextEncoder();
const decoder = new TextDecoder();

const Base64 = {
  stringify: (input: string | Uint8Array, options?: { pad: boolean }) => (
    base64.stringify(typeof input === 'string' ? encoder.encode(input) : input, options)
  ),
  parse: (input: string) => decoder.decode(base64.parse(input, { loose: true })),
};

export default Base64;
